import { Link } from "react-router-dom";

export interface Crumb {
  label: string;
  to?: string;
}

function Breadcrumb({ crumbs }: { crumbs: Crumb[] }) {
  return (
    <nav
      aria-label="面包屑导航"
      className="flex flex-wrap items-center gap-1.5 text-sm text-foreground-500"
    >
      {crumbs.map((c, i) => (
        <span key={`${c.label}-${i}`} className="flex items-center gap-1.5">
          {i > 0 && <i className="ri-arrow-right-s-line text-foreground-300" />}
          {c.to ? (
            <Link to={c.to} className="hover:text-primary-600">
              {c.label}
            </Link>
          ) : (
            <span className="truncate text-foreground-800">{c.label}</span>
          )}
        </span>
      ))}
    </nav>
  );
}

export default Breadcrumb;